<template>
  <div>
    <div class="case-message mt-2">
      Dermatology case <b>{{accessionNumber}}</b> has been submitted.
    </div>
    <!-- qrText={{qrText}} -->

       <!-- once your case has been reviewed. -->
   <div class="close-message mt-2">
      You will be contacted by your dermatologist’s office once your case has been reviewed.
      <!-- Please take a screenshot of this Case ID. -->
    </div>    

<!-- QR is temporarily disabled!!! -->
    <qrcode-vue v-if="false && qrText!=''" :value="qrText" size="200" level="H"
      class="mt-2 mb-1"></qrcode-vue>

    <div class="close-message mt-2">
      You can close this window.
    </div>
  </div>
</template>

<script>
import {defineString} from '@/components/globals.js';
import QrcodeVue from 'qrcode.vue'


export default {
  components: {
    QrcodeVue
  },

  computed: {
    accessionNumber() {
      const accnum = defineString(this.$store.getters['form/accessionNumber']);
      return (accnum != '') ? '#'+accnum : '';
    },
    qrText() {
      return this.$store.getters['form/qrText']
    },
  },
}
</script>


<style scoped>
.case-message {
  font-size: 1.2em;
  line-height: 1em;
}

.close-message {
  font-family: Arial, Helvetica, sans-serif !important;
  line-height: 1em;
}
</style>